<template>
  <div>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-9 col-sm-9' style='padding: 10px 0px 5px 5px;'>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
            <span>المستخدم:</span>
            <input  @keypress="isLocked($event)" :value='record.user_name' class='form-control' name='notes' type='text'>
          </div>
          <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 5px 10px;'>
            <span>وصف مختصر:</span>
            <input  maxlength="15" :value='record.user_name' class='form-control' name='notes' type='text'>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
            <span>التاريخ:</span>
            <input  @keypress="isLocked($event)" :value='record.date' class='form-control' name='notes' type='text'>
          </div>
          <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 5px 10px;'>
            <span>الحالة:</span>
            <select class="form-control" style="padding: 0px" v-model="record.call_type_id">
              <option v-for="item in types" v-bind:key="item.id" v-bind:value="item.id">
                {{item.name}}
              </option>
            </select>
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
            <span>التفاصيل:</span>
            <textarea class="form-control" rows="4" v-model="record.notes"></textarea>
          </div>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 30px 0px 5px 0px;'>
          <div class="panel panel-default">
              <div class="panel-heading" style='padding: 5px;'>
                  <i class="fa fa-bell fa-fw"></i> المشاكل
              </div>
              <!-- /.panel-heading -->
              <div class="panel-body" style='padding: 5px;'>
                  <div class="list-group">
                      <a href="#" class="list-group-item" style='padding: 5px;' v-for='record in records' :key='record.id' v-on:click="showForm(record)">
                           {{record.time}}
                          <span class="pull-right text-muted small"><em>{{record.date}}</em>
                          </span>
                      </a>
                  </div>
                  <!-- /.list-group -->
              </div>
              <!-- /.panel-body -->
          </div>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;  text-align:center;'>
          <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
          <button v-show="$per.value.saveReceipt" @click='showForm(0)'  type='button' class='btn btn-primary btn-outline btn-sm'>جديد</button>
          <button v-show="($per.value.saveReceipt && record.id === 0 ) || ($per.value.editReceipt && record.id > 0 )" @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          <button v-show="record.id > 0 " @click='deleteData(selectedrec)' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
        <table width='100%' class='table  table-bordered ' >
          <thead>
            <tr>
              <th style='text-align: center'>التاريخ</th>
              <th style='text-align: center'>الوقت</th>
              <th style='text-align: center'>الغرض</th>
              <th style='text-align: center'>الحالة</th>
              <th style='text-align: center'>الاجراء</th>
              <th style='text-align: center'>المستخدم</th>
            </tr>
          </thead>
          <tbody v-if="!$per.value.editReceipt">
            <tr v-for='record in records' :key='record.id'>
              <td style="padding:2px" align='center'>{{record.date}}</td>
              <td style="padding:2px" align='center'>{{record.time}}</td>
              <td style="padding:2px" align='center'>{{record.call_type}}</td>
              <td style="padding:2px" align='center'>{{record.call_status}}</td>
              <td style="padding:2px" align='center'>{{record.call_action}}</td>
              <td style="padding:2px" align='center'>{{record.user_name}}</td>
            </tr>
          </tbody>
          <tbody  v-if="$per.value.editReceipt">
            <tr :class="{highlight :selectedrec == record.id}"  v-for='record in records' :key='record.id' v-on:click="showForm(record)">
              <td style="padding:2px" align='center'>{{record.date}}</td>
              <td style="padding:2px" align='center'>{{record.time}}</td>
              <td style="padding:2px" align='center'>{{record.call_type}}</td>
              <td style="padding:2px" align='center'>{{record.call_status}}</td>
              <td style="padding:2px" align='center'>{{record.call_action}}</td>
              <td style="padding:2px" align='center'>{{record.user_name}}</td>
            </tr>
          </tbody>
        </table>
        <!-- /.table-responsive -->
        </div>
        <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
export default {
  name: 'CallLogs',
  data () {
    return {
      validationErrors: '',
      records: {},
      record: {},
      types: [{id: 0, name: 'غير نشط'}, {id: 1, name: 'نشط'}],
      actions: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      selectedrec: null,
      Localcontract_id: 0
    }
  },
  methods: {
    isLocked: function (evt) {
      evt.preventDefault()
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    tabSelected () {
      this.GetData()
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      this.validationErrors = ''
      this.record = ''
      this.records = ''
      this.selectedrec = 0
      this.showForm(0)
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-customer-call-logs', {
        token: localStorage.getItem('token'),
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.isLoadingData = false
          this.records = res.data.Data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      var userID = JSON.parse(localStorage.getItem('main_data'))
      var today = new Date()
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      if (recID === 0) {
        this.record = {'id': 0, 'customer_id': '', 'call_type_id': '', 'call_status_id': '', 'action_id': '', 'call_delay': 0, 'notes': '', 'time': '', 'user_name': userID[0].value, 'date': date}
      } else {
        this.record = recID
      }
      this.errorShow = false
      this.successShow = false
      this.selectedrec = recID.id
      this.error = ''
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'save-call-logs', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        customer_id: this.$store.state.customerData.id,
        call_type_id: this.record.call_type_id,
        call_status_id: this.record.call_status_id,
        action_id: this.record.action_id,
        call_delay: this.record.call_delay,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          this.records = res.data
          this.selectedrec = 0
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.successShow = false
      this.errorShow = false
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'delete-call-logs', {
        token: localStorage.getItem('token'),
        id: this.record.id
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(this.record.id)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.errors === 'id not found') {
            this.validationErrors = {0: 'عفوا يرجى اختيار سجل أولا'}
            this.errorShow = true
            this.isLoadingSave = false
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/Problems.vue